!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define(t)
    : ((e =
        "undefined" != typeof globalThis
          ? globalThis
          : e || self).dayjs_plugin_customParseFormat = t());
})(this, function () {
  "use strict";
  var e = {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A",
    },
    t =
      /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,
    n = /\d/,
    r = /\d\d/,
    i = /\d\d?/,
    o = /\d*[^-_:/,()\s\d]+/,
    s = {},
    a = function (e) {
      return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
  var f = function (e) {
      return function (t) {
        this[e] = +t;
      };
    },
    h = [
      /[+-]\d\d:?(\d\d)?|Z/,
      function (e) {
        (this.zone || (this.zone = {})).offset = (function (e) {
          if (!e) return 0;
          if ("Z" === e) return 0;
          var t = e.match(/([+-]|\d\d)/g),
            n = 60 * t[1] + (+t[2] || 0);
          return 0 === n ? 0 : "+" === t[0] ? -n : n;
        })(e);
      },
    ],
    u = function (e) {
      var t = s[e];
      return t && (t.indexOf ? t : t.s.concat(t.f));
    },
    d = function (e, t) {
      var n,
        r = s.meridiem;
      if (r) {
        for (var i = 1; i <= 24; i += 1)
          if (e.indexOf(r(i, 0, t)) > -1) {
            n = i > 12;
            break;
          }
      } else n = e === (t ? "pm" : "PM");
      return n;
    },
    c = {
      A: [
        o,
        function (e) {
          this.afternoon = d(e, !1);
        },
      ],
      a: [
        o,
        function (e) {
          this.afternoon = d(e, !0);
        },
      ],
      Q: [
        n,
        function (e) {
          this.month = 3 * (e - 1) + 1;
        },
      ],
      S: [
        n,
        function (e) {
          this.milliseconds = 100 * +e;
        },
      ],
      SS: [
        r,
        function (e) {
          this.milliseconds = 10 * +e;
        },
      ],
      SSS: [
        /\d{3}/,
        function (e) {
          this.milliseconds = +e;
        },
      ],
      s: [i, f("seconds")],
      ss: [i, f("seconds")],
      m: [i, f("minutes")],
      mm: [i, f("minutes")],
      H: [i, f("hours")],
      h: [i, f("hours")],
      HH: [i, f("hours")],
      hh: [i, f("hours")],
      D: [i, f("day")],
      DD: [r, f("day")],
      Do: [
        o,
        function (e) {
          var t = s.ordinal,
            n = e.match(/\d+/);
          if (((this.day = n[0]), t))
            for (var r = 1; r <= 31; r += 1)
              t(r).replace(/\[|\]/g, "") === e && (this.day = r);
        },
      ],
      w: [i, f("week")],
      ww: [r, f("week")],
      M: [i, f("month")],
      MM: [r, f("month")],
      MMM: [
        o,
        function (e) {
          var t = u("months"),
            n =
              (
                u("monthsShort") ||
                t.map(function (e) {
                  return e.slice(0, 3);
                })
              ).indexOf(e) + 1;
          if (n < 1) throw new Error();
          this.month = n % 12 || n;
        },
      ],
      MMMM: [
        o,
        function (e) {
          var t = u("months").indexOf(e) + 1;
          if (t < 1) throw new Error();
          this.month = t % 12 || t;
        },
      ],
      Y: [/[+-]?\d+/, f("year")],
      YY: [
        r,
        function (e) {
          this.year = a(e);
        },
      ],
      YYYY: [/\d{4}/, f("year")],
      Z: h,
      ZZ: h,
    };
  function l(n) {
    var r, i;
    (r = n), (i = s && s.formats);
    for (
      var o = (n = r.replace(
          /(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,
          function (t, n, r) {
            var o = r && r.toUpperCase();
            return (
              n ||
              i[r] ||
              e[r] ||
              i[o].replace(
                /(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,
                function (e, t, n) {
                  return t || n.slice(1);
                }
              )
            );
          }
        )).match(t),
        a = o.length,
        f = 0;
      f < a;
      f += 1
    ) {
      var h = o[f],
        u = c[h],
        d = u && u[0],
        l = u && u[1];
      o[f] = l ? { regex: d, parser: l } : h.replace(/^\[|\]$/g, "");
    }
    return function (e) {
      for (var t = {}, n = 0, r = 0; n < a; n += 1) {
        var i = o[n];
        if ("string" == typeof i) r += i.length;
        else {
          var s = i.regex,
            f = i.parser,
            h = e.slice(r),
            u = s.exec(h)[0];
          f.call(t, u), (e = e.replace(u, ""));
        }
      }
      return (
        (function (e) {
          var t = e.afternoon;
          if (void 0 !== t) {
            var n = e.hours;
            t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0),
              delete e.afternoon;
          }
        })(t),
        t
      );
    };
  }
  return function (e, t, n) {
    (n.p.customParseFormat = !0),
      e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
    var r = t.prototype,
      i = r.parse;
    r.parse = function (e) {
      var t = e.date,
        r = e.utc,
        o = e.args;
      this.$u = r;
      var a = o[1];
      if ("string" == typeof a) {
        var f = !0 === o[2],
          h = !0 === o[3],
          u = f || h,
          d = o[2];
        h && (d = o[2]),
          (s = this.$locale()),
          !f && d && (s = n.Ls[d]),
          (this.$d = (function (e, t, n, r) {
            try {
              if (["x", "X"].indexOf(t) > -1)
                return new Date(("X" === t ? 1e3 : 1) * e);
              var i = l(t)(e),
                o = i.year,
                s = i.month,
                a = i.day,
                f = i.hours,
                h = i.minutes,
                u = i.seconds,
                d = i.milliseconds,
                c = i.zone,
                m = i.week,
                M = new Date(),
                Y = a || (o || s ? 1 : M.getDate()),
                p = o || M.getFullYear(),
                v = 0;
              (o && !s) || (v = s > 0 ? s - 1 : M.getMonth());
              var D,
                w = f || 0,
                g = h || 0,
                y = u || 0,
                L = d || 0;
              return c
                ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3))
                : n
                ? new Date(Date.UTC(p, v, Y, w, g, y, L))
                : ((D = new Date(p, v, Y, w, g, y, L)),
                  m && (D = r(D).week(m).toDate()),
                  D);
            } catch (e) {
              return new Date("");
            }
          })(t, a, r, n)),
          this.init(),
          d && !0 !== d && (this.$L = this.locale(d).$L),
          u && t != this.format(a) && (this.$d = new Date("")),
          (s = {});
      } else if (a instanceof Array)
        for (var c = a.length, m = 1; m <= c; m += 1) {
          o[1] = a[m - 1];
          var M = n.apply(this, o);
          if (M.isValid()) {
            (this.$d = M.$d), (this.$L = M.$L), this.init();
            break;
          }
          m === c && (this.$d = new Date(""));
        }
      else i.call(this, e);
    };
  };
});
